(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gn2-routine"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gould-routine'))customElements.define('gould-routine',class extends HTMLElement{connectedCallback(){this.querySelectorAll('[data-choice]').forEach(button=>button.addEventListener('click',()=>{this.querySelectorAll('[data-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelectorAll('[data-result]').forEach(p=>p.hidden=p.dataset.result!==button.dataset.choice)}))}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn2-science"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gould-science')){customElements.define('gould-science',class extends HTMLElement{connectedCallback(){const tabs=[...this.querySelectorAll('[role=tab]')];const panels=[...this.querySelectorAll('[role=tabpanel]')];const activate=(i,focus=false)=>{tabs.forEach((t,j)=>{t.setAttribute('aria-selected',String(i===j));t.tabIndex=i===j?0:-1;panels[j].hidden=i!==j});if(focus)tabs[i].focus()};tabs.forEach((t,i)=>{t.addEventListener('click',()=>activate(i));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(n,true)})})}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gn3-product"]) return;
  try {
    
if(!customElements.get('gould-gallery'))customElements.define('gould-gallery',class extends HTMLElement{connectedCallback(){this.querySelectorAll('[data-gallery-index]').forEach(button=>button.addEventListener('click',()=>{this.querySelectorAll('[data-gallery-index]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelectorAll('[data-gallery-slide]').forEach(img=>img.hidden=img.dataset.gallerySlide!==button.dataset.galleryIndex)}))}});
if(!customElements.get('gould-purchase'))customElements.define('gould-purchase',class extends HTMLElement{connectedCallback(){this.addEventListener('change',()=>{const quantity=Number(this.querySelector('input:checked')?.value||1);this.querySelector('[data-total]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'}).format(Number(this.dataset.price)*quantity/100)})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gould-header"]) return;
  try {
    
if (!customElements.get('gould-navigation')) {
  customElements.define('gould-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const dialog = this.querySelector('dialog');
      const root = this.querySelector('.gnx-mobile-root');
      const opener = this.querySelector('[data-open-menu]');
      const dropdowns = [...this.querySelectorAll('.gnx-dropdown')];
      let activeTrigger;
      const reset = () => {
        root.hidden = false;
        this.querySelectorAll('[data-panel]').forEach(panel => panel.hidden = true);
        dialog.scrollTop = 0;
      };
      opener.addEventListener('click', () => {
        reset();
        dropdowns.forEach(d => d.open = false);
        dialog.showModal();
        document.documentElement.classList.add('gnx-menu-open');
      }, {signal});
      this.querySelector('[data-close-menu]').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('gnx-menu-open');
        reset();
        if (opener.getClientRects().length) opener.focus();
      }, {signal});
      this.querySelectorAll('[data-show-panel]').forEach(button => button.addEventListener('click', () => {
        activeTrigger = button;
        root.hidden = true;
        const panel = this.querySelector('[data-panel="' + button.dataset.showPanel + '"]');
        panel.hidden = false;
        dialog.scrollTop = 0;
        panel.querySelector('[data-back]').focus();
      }, {signal}));
      this.querySelectorAll('[data-back]').forEach(button => button.addEventListener('click', () => {
        reset();
        activeTrigger?.focus();
      }, {signal}));
      this.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
        if (dialog.open) dialog.close();
        dropdowns.forEach(d => d.open = false);
      }, {signal}));
      dropdowns.forEach(details => details.querySelector('summary').addEventListener('click', () => {
        dropdowns.filter(d => d !== details).forEach(d => d.open = false);
      }, {signal}));
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) dropdowns.forEach(d => d.open = false);
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !dialog.open) {
          const opened = dropdowns.find(d => d.open);
          if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
        }
      }, {signal});
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) dropdowns.forEach(d => d.open = false);
      }, {signal});
      window.matchMedia('(min-width: 990px)').addEventListener('change', event => {
        if (event.matches && dialog.open) dialog.close();
        dropdowns.forEach(d => d.open = false);
      }, {signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.documentElement.classList.remove('gnx-menu-open');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
